import { Box, Typography } from "@mui/material"
import { icons } from "../../../../../../utils/icons"
import { useContextState } from "../../../../../../hooks/theme"



export const NotSolicitedUsers = ({ title }: { title: string }) => {

    const { colors } = useContextState()

    return (
        <Box sx={{
            marginTop: 3,
            marginBottom: 3,
            width: '100%',
            display: 'flex',
            gap: 1,
            justifyContent: 'center',
            alignItems: 'center',
            color: colors.color32,
            '& .MuiTypography-root': {
                fontSize: '14px'
            },
            '& .MuiSvgIcon-root': {
                fontSize: '2rem'
            }
        }}>

            {icons('userAccount')}

            <Typography>{title}</Typography>

        </Box>
    )
}